import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import PortfolioDetailV2 from "../../../StudentPortfolio/routes/PortfolioDetailsV2";
export default store => ({
  path: "students",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "course-students" */ "../../../StudentPortfolio/components"
        ),
        import(
          /* webpackChunkName: "course-students" */ "../../../StudentPortfolio/modules/StudentPortfolioModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "studentPortfolio",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [PortfolioDetailV2(store)],
});
